import React from 'react';
import '../styles/Projects.css';
import { FiExternalLink } from 'react-icons/fi'; 

import RestaurantImg from './1st.png'; 
import PortfolioImg from './2nd.png';
import weather from './3rd.png';
import app from './4th.png';
import blog from './5th.png';
import event from './6th.png';

const Projects = () => {
    const projects = [
        {
            id: 1,
            title: "Restaurant site",
            image: RestaurantImg,
            description: "A fully responsive restaurant platform featuring an interactive digital menu, real-time table reservation system, and seamless integration for online food ordering.",
            technologies: ["HTML5", "CSS3", "JavaScript", "Bootstrap"],
            liveLink: "https://hina139.github.io/Resaturant-Site-Clone/",
        },
        {
            id: 2,
            title: "About Me Portfolio",
            image: PortfolioImg,
            description: "A professional dark-themed portfolio website with smooth scrolling, project gallery, and custom animations, built for Anas.",
            technologies: ["HTML5", "CSS3", "JavaScript", "GitHub Pages"],
            liveLink: "https://hina139.github.io/anas-portfolio/",
        },
        {
            id: 3,
            title: "Real Time Weather App",
            image: weather,
            description: "Real-time weather tracking app that delivers accurate local and global weather updates. Features dynamic background changes and instant search.",
            technologies: ["HTML5", "CSS3", "JavaScript"],
            liveLink: "https://hina139.github.io/live-weather-app/",
        },
        {
            id: 4,
            title: "Car Rental Expo App",
            image: app,
            description: "A premium mobile application for car rentals featuring a dynamic vehicle showcase, advanced filtering, and a streamlined booking process.",
            technologies: ["React Native", "Expo", "Tailwind CSS", "JavaScript","Firebase" , "Firestore"],
            liveLink: "https://hackathone-expo-app.web.app/",
        },
        {
            id: 5,
            title: "Blog Platform",
            image: blog,
            description: "A full-stack blogging platform with Firebase Authentication and Firestore for real-time data storage and CRUD operations.",
            technologies: ["React", "Tailwind", "Firebase", "Firestore"],
            liveLink: "https://blogplatform-7c82e.web.app/login",
        },
        {
            id: 6,
            title: "Event Management",
            image: event,
            description: "A MERN stack event planning solution featuring CRUD operations, attendee tracking, and a secure REST API.",
            technologies: ["React", "Bootstrap", "Firebase" , "Firestore"],
            liveLink: "https://hackathon-test-6597d.web.app/login",
        }
    ];

    return (
        <section className="projects-section" id="projects">
            <div className="container">
                <div className="projects-header">
                    <h2 className="section-title">My <span className="highlight">Projects</span></h2>
                    <p className="section-subtitle">Showcasing my latest web development work and technologies used</p>
                </div>

                <div className="projects-grid">
                    {projects.map((project) => (
                        <div key={project.id} className="project-card">
                            {/* Image Section - Now Smaller */}
                            <div className="project-img-frame">
                                <img 
                                    src={project.image} 
                                    alt={project.title}
                                    className="project-thumb"
                                />
                            </div>

                            {/* Content Section - Card size increased here */}
                            <div className="project-body">
                                <h3 className="project-heading">{project.title}</h3>
                                <p className="project-text">{project.description}</p>
                                
                                <div className="project-footer">
                                    <div className="tech-stack-pills">
                                        {project.technologies.map((tech, index) => (
                                            <span key={index} className="tech-pill-item">{tech}</span>
                                        ))}
                                    </div>
                                    
                                    {/* Live Icon - Bottom Right */}
                                    <a 
                                        href={project.liveLink} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="btn-live-icon"
                                    >
                                        <FiExternalLink size={18} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;